/* eslint-disable no-underscore-dangle */

import { createStore, compose } from 'redux';
import reducers from './reducers';
import middlewares from './middlewares';

const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (v) => v;

const enhancer = process.env.NODE_ENV !== 'production' ? compose(middlewares, devTools) : middlewares;
export default (initialState) => createStore(reducers, initialState, enhancer);
